import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=205f7561&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=ts"
export * from "./BaseInput.vue?vue&type=script&lang=ts"
import style0 from "./BaseInput.vue?vue&type=style&index=0&id=205f7561&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205f7561",
  null
  
)

export default component.exports